import Vue from 'vue';
import validate from '@milestoneslabs/milestones-js-engine/src/Plugins/validateJs';
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import isEmpty from 'lodash/isEmpty';
import {passwordValidations} from "@milestoneslabs/milestones-ui-kit/src/helpers/messages";


validate.validators.phoneNumber = (value, options, key, attributes) => {
    let message = [];
    const country = options.hasOwnProperty('country') ? options.country : 'US';
    const phoneNumber = value ? parsePhoneNumberFromString(value, country) : undefined;
    const presence = options.hasOwnProperty('presence') ? options.presence : false;

    if (presence && isEmpty(phoneNumber)) {
        message.push('is required!');
        return message;
    }

    if (phoneNumber) {
        if (!phoneNumber.isValid()) {
            message.push('is not a valid phone number!');
            return message;
        }

        if (!phoneNumber.isPossible()) {
            message.push('is not an existing phone number!');
            return message;
        }
    }

    return message;
};

validate.validators.password = (value, options) => {

    let messages = [];

    let presence = options.hasOwnProperty('presence')
        ? options.presence
        : false;

    if (presence && isEmpty(value)) {
        messages.push('is required!');
        return messages;
    }

    if (value) {
        passwordValidations.forEach((validation) => {
            if (!validation.validationMethod(value)) {
                messages.push(validation.text);
            }
        });
    }

    return messages;
};


Vue.prototype.$validate = validate;

export default validate;
